<template>
    <span>
		<div @click="close(pix, true)" class="col-md-10">
			Recebemos pagamento via PIX do pedido #{{ pix.transaction_id }}, obrigado! 
			<div class="space-10"></div>
			<strong class="font-16"> Valor da Recarga: {{ pix.balance | money }} </strong>  
          <br>
        </div>
        <div class="col-md-1" @click="close(pix)">
          <i class="fa fa-window-close icon"></i> 
        </div>

		<div class="space-50"></div>
        <small class="pull-right">{{ pix.date | time }}</small>
    </span>
</template>

<script>
export default {
  name: 'PixNotification',
  props: {
    pix: {
      type: Object,
      required: true
    }
  },
  methods: {
    close (pix, navigatorTo = false) {
      if (navigatorTo) {
        this.$router.push({name: 'finances_dashboard'})
      }
      this.$emit('decreaseNotification', pix)
    }
  }
}
</script>

<style scoped>  
  .icon {
    color: #189ce2;
    border-color: #168ccb;
    font-size: 1.8rem;
	margin: -5px;
  }

</style>



// WEBPACK FOOTER //
// PixNotification.vue?628e5d7c